import { Command } from 'commander';
import chalk from 'chalk';
import { SkillsService } from '../../services/skills.service.js';
import { ConfigService } from '../../services/config.service.js';
import { ValidationError } from '../../errors/index.js';

export function createSkillsInspectCommand(): Command {
    return new Command('inspect')
        .description('Inspect skill metadata and contents without installing')
        .argument('<candidate-id>', 'Candidate ID from "j skills find --json"')
        .option('--json', 'Output machine-readable JSON')
        .option('--deep', 'Include bounded executable/config contents for security review')
        .option('--refresh', 'Bypass cached provider data')
        .action(async (
            candidateId: string,
            options: { json?: boolean; deep?: boolean; refresh?: boolean },
            command: Command,
        ) => {
            const config = candidateId.startsWith('jai1:')
                ? await new ConfigService().load()
                : undefined;
            if (candidateId.startsWith('jai1:') && !config) {
                throw new ValidationError('Chưa xác thực. Chạy "jai1 auth" trước.');
            }
            const detail = await new SkillsService().inspectCandidate(candidateId, {
                deep: options.deep,
                refresh: options.refresh,
                config,
            });

            const rootOptions = command.parent?.parent?.opts<{ json?: boolean }>();
            if (options.json || rootOptions?.json) {
                console.log(JSON.stringify(detail, null, 2));
                return;
            }

            console.log(chalk.bold(`\n${detail.candidate.name}`));
            console.log(chalk.dim(detail.candidate.id));
            if (detail.candidate.description) console.log(detail.candidate.description);
            console.log(chalk.dim(`Files: ${detail.files.length} · Risk: ${detail.risk.status}`));
        });
}
